import { useNavigate } from 'react-router-dom';
import { Button } from '@scholastic/mockingjay';
import { APPLICATION_CODE_ROUTES } from '@/constants';
import { useApplications } from '@/hooks/api/use-application/use-application';
import { getApplicationLaunchRoute } from '@/util/getApplicationLaunchRoute';
import { useAccessCodeRedemptionContext } from './AccessCodeRedemptionContext';
import { isSameDeepLinkCode } from './access-code-deep-link';

export function RedemptionSuccessActions() {
  const navigate = useNavigate();
  const { setIsDialogOpen, redemptionData, pendingAppLaunch } =
    useAccessCodeRedemptionContext();
  const { data: applications } = useApplications();

  const productCode = redemptionData.product?.productCode;
  const application = applications?.find((candidate) =>
    candidate.productCodes?.some((code) =>
      isSameDeepLinkCode(code, productCode)
    )
  );

  const isStateForThisProduct =
    isSameDeepLinkCode(pendingAppLaunch?.app, application?.applicationCode) ||
    isSameDeepLinkCode(pendingAppLaunch?.app, productCode);
  const deepLinkState = isStateForThisProduct
    ? pendingAppLaunch?.appState
    : null;

  const handleClose = () => {
    setIsDialogOpen(false);
  };

  const handleLaunch = () => {
    if (!application) {
      return;
    }

    const { applicationCode, nativeApplication } = application;
    // Only the launch route carries a state; without one, match the home tile.
    const inAppRoute = nativeApplication
      ? APPLICATION_CODE_ROUTES[applicationCode]
      : undefined;
    const useInAppRoute = Boolean(inAppRoute) && !deepLinkState;

    const launchRoute = useInAppRoute
      ? getApplicationLaunchRoute(applicationCode, true)
      : getApplicationLaunchRoute(
          applicationCode,
          false,
          deepLinkState ?? undefined
        );

    setIsDialogOpen(false);

    if (useInAppRoute) {
      navigate(launchRoute);
      return;
    }

    window.location.assign(launchRoute);
  };

  return (
    <div className="flex flex-col justify-end gap-2 px-8 pb-8 pt-6 tablet:flex-row">
      <Button
        variant="secondary"
        onClick={handleClose}
        data-testid="redemption-success-ok-button"
      >
        OK
      </Button>
      {application && (
        <Button
          variant="primary"
          onClick={handleLaunch}
          data-testid="redemption-success-launch-button"
        >
          Launch product
        </Button>
      )}
    </div>
  );
}
